<template>
  <div id="app" v-browser-navigation>
      <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
@import 'vue-awesome-notifications/dist/styles/style.css';

</style>



// WEBPACK FOOTER //
// src/components/public/App.vue